import React, {
  FunctionComponent,
  Suspense,
  useCallback,
  useState,
} from 'react';

import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';
import { UserAvatar } from '@savgroup-front-common/primitive/components/user-avatar';
import { Button } from '@savgroup-front-common/primitive/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from '@savgroup-front-common/primitive/ui/dropdown-menu';
import { Skeleton } from '@savgroup-front-common/primitive/ui/skeleton';

import { useDefaultLanguage, useUserTracking } from './hooks';
import HeaderProfileMenu from './Menu';

const HeaderProfile: FunctionComponent = () => {
  const { firstname, lastname } = useCurrentUser();

  useDefaultLanguage();
  useUserTracking();
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="menu"
          size="icon-sm"
          data-testid="profilButton"
          aria-expanded={isOpen}
          className="rounded-lg"
        >
          <UserAvatar
            variant="primary"
            shape="square"
            fullName={`${firstname || ''} ${lastname || ''}`}
          />
        </Button>
      </DropdownMenuTrigger>

      <Suspense fallback={<Skeleton className="size-8 rounded-lg" />}>
        <HeaderProfileMenu onClose={handleClose} />
      </Suspense>
    </DropdownMenu>
  );
};

export default React.memo(HeaderProfile);
